import mstBanner from "../assets/mst-banner.jpg";
import benShulman from "../assets/ben-shulman.jpg";
import tylerHeisey from "../assets/tyler-heisey.png";
import sheilaDugan from "../assets/sheila-dugan.jpg";
import karlaWente from "../assets/Karla_Wente.jpg";
import arianaVidana from "../assets/ariana-vidana.jpg";
import merdijanaKovacevic from "../assets/Merdijana-Kovacevic.jpg";
import liaSmith from "../assets/Smith_Lia.jpg";
import alanaShapiro from "../assets/alana-shapiro.png";

export const mstSeries2026Data = {
  title: "MST and Healing: Conversations on Health, Relationships, and Care",
  eyebrow: "Free webinar series for clinical providers and community professionals",
  subtitle: "Wednesdays in April 2026, 12:00 PM - 1:00 PM Central",
  heroImage: mstBanner,
  learningObjectives: [
    "Recognize gender-specific factors for providers working with survivors of military sexual trauma.",
    "Describe best practices in trauma-informed pelvic health examination techniques.",
    "Examine relational dynamics relevant to treatment of MST survivors and couples.",
    "Summarize treatment considerations for MST survivors with co-occurring substance use and eating disorders.",
  ],
  sessions: [
    {
      eventId: "mst-webinar-2026-04-08",
      dateLabel: "Wednesday, April 8, 2026",
      shortLabel: "Apr 8",
      title: "Gender Considerations for Providers Working With MST",
      speakers: [
        {
          name: "Ben Shulman",
          credentials: "MA, LCPC",
          role: "Presenter",
          affiliation: "Road Home Program at Rush",
          bio: "Clinician focused on trauma recovery and evidence-based care for service members and veterans.",
          image: benShulman,
          alt: "Portrait of Ben Shulman",
        },
        {
          name: "Tyler Heisey",
          credentials: "MA, LPC",
          role: "Presenter",
          affiliation: "Road Home Program at Rush",
          image: tylerHeisey,
          alt: "Portrait of Tyler Heisey",
        },
      ],
    },
    {
      eventId: "mst-webinar-2026-04-15",
      dateLabel: "Wednesday, April 15, 2026",
      shortLabel: "Apr 15",
      title:
        "Pathways to Wellness for Military Sexual Trauma (MST): Moving Toward Pelvic Health",
      speakers: [
        {
          name: "Sheila Dugan",
          credentials: "MD",
          role: "Presenter",
          image: sheilaDugan,
          alt: "Portrait of Sheila Dugan",
        },
        {
          name: "Karla Wente",
          credentials: "PT, DPT, PhD",
          role: "Presenter",
          image: karlaWente,
          alt: "Portrait of Karla Wente",
        },
      ],
    },
    {
      eventId: "mst-webinar-2026-04-22",
      dateLabel: "Wednesday, April 22, 2026",
      shortLabel: "Apr 22",
      title: "MST and Relationships: Healing and Treatment for Survivors and Couples",
      speakers: [
        {
          name: "Ariana Vidaña",
          credentials: "PhD",
          role: "Presenter",
          image: arianaVidana,
          alt: "Portrait of Ariana Vidaña",
        },
        {
          name: "Merdijana Kovacevic",
          credentials: "PhD",
          role: "Presenter",
          image: merdijanaKovacevic,
          alt: "Portrait of Merdijana Kovacevic",
        },
      ],
    },
    {
      eventId: "mst-webinar-2026-04-29",
      dateLabel: "Wednesday, April 29, 2026",
      shortLabel: "Apr 29",
      title:
        "Co-Occurring Eating Disorders and Substance Use in MST Survivors: Overview and Clinical Implications",
      speakers: [
        {
          name: "Lia Smith",
          credentials: "PhD",
          role: "Presenter",
          image: liaSmith,
          alt: "Portrait of Lia Smith",
        },
        {
          name: "Alana Shapiro",
          credentials: "LCSW",
          role: "Presenter",
          image: alanaShapiro,
          alt: "Portrait of Alana Shapiro",
        },
      ],
    },
  ],
  ceDisclosureAccreditation: {
    ce: "Each webinar is eligible for 1 CE credit.",
    disclosures:
      "The course director(s), planner(s), faculty, and reviewer(s) of this activity have no relevant financial relationship(s) with ineligible companies to disclose.",
    accreditation:
      "In support of improving patient care, Rush University Medical Center is jointly accredited by the Accreditation Council for Continuing Medical Education (ACCME), the Accreditation Council for Pharmacy Education (ACPE), and the American Nurses Credentialing Center (ANCC), to provide continuing education for the healthcare team.",
  },
  contactInfo: {
    email: "events@roadhomeprogram.org",
    phone: "(312) 942-8387 (VETS)",
  },
};
